import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export const ProtectedRoute = ({ children, allowedRoles }) => {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="flex flex-col items-center gap-4">
          <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user?.role)) {
    // Redirect to appropriate dashboard based on role
    const dashboardRoutes = {
      super_admin: '/dashboard',
      admin: '/dashboard',
      manager: '/dashboard',
      staff: '/staff-dashboard',
      client: '/client-dashboard',
    };
    return <Navigate to={dashboardRoutes[user?.role] || '/dashboard'} replace />;
  }

  return children;
};

export const PublicRoute = ({ children }) => {
  const { isAuthenticated, loading, user } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  if (isAuthenticated) {
    const dashboardRoutes = {
      super_admin: '/dashboard',
      admin: '/dashboard',
      manager: '/dashboard',
      staff: '/staff-dashboard',
      client: '/client-dashboard',
    };
    return <Navigate to={dashboardRoutes[user?.role] || '/dashboard'} replace />;
  }

  return children;
};

export default ProtectedRoute;
